import React, { useContext, useMemo } from "react";
import { ReportingContext, ReportingProvider } from "../reporting-context-file";
import ReportingHeading from "../components/reporting-heading";
import styles from "@/page-components/reporting/reporting.module.css";
import ReportingTableComponent from "../components/reporting-center-table";
import HeaderTabsComponents from "../components/header-tabs-component";
import FilterSection from "../components/filter-section/filter-section";
import DeleteConfirmationModal from "../components/delete-conformation-modal";
import { useReportDelete } from "@/services/reporting/delete-report.repo";

const AzureReporting = () => {
  return (
    <ReportingProvider>
      <ReportingPage />
    </ReportingProvider>
  );
};

const ReportingPage = () => {
  const context = useContext(ReportingContext);
  const service = "azure";

  const DeleteQuery = useMemo(
    () => ({
      service: service,
      id: context?.SelectReportID,
    }),
    [context?.SelectReportID]
  );

  const {
    data: deleteData,
    isLoading: deleteLoading,
    error: deleteError,
    isSuccess: deleteSuccess,
  } = useReportDelete(DeleteQuery, [], !!context?.SelectReportID);

  return (
    <>
      <div className={styles.stats_table}>
        <HeaderTabsComponents />
        <div className={styles.main_container}>
          <div className={styles.heading_table}>
            <ReportingHeading
              service={service}
              deleteError={deleteError}
              deleteSuccess={deleteSuccess}
              deleteLoading={deleteLoading}
            />
            <ReportingTableComponent
              service={service}
              deleteSuccess={deleteSuccess}
            />
          </div>
          <div style={{ width: "19%" }}>
            <FilterSection service={service} />
          </div>
        </div>
      </div>

      {context?.confirmationmodal && (
        <div className={styles.customeOverlay}>
          <div className={styles.conformationBox}>
            <DeleteConfirmationModal
              deleteLoading={deleteLoading}
              deleteData={deleteData}
              name="Report"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AzureReporting;
